export default {
      id: "timer-separator-usage",
      viewBox: "0 0 39 115",
      url: __webpack_public_path__ + "img/icons.e748fd75.svg#timer-separator",
      toString: function () {
        return this.url;
      }
    }